import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Blog from './pages/Blog';
import SinglePost from './pages/SinglePost';
import About from './pages/About';
import Contact from './pages/Contact';
import VideoHub from './pages/VideoHub';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminPosts from './pages/admin/AdminPosts';
import AdminPostForm from './pages/admin/AdminPostForm';
import AdminVideos from './pages/admin/AdminVideos';
import AdminSubscribers from './pages/admin/AdminSubscribers';
import AdminContacts from './pages/admin/AdminContacts';
import AdminConfig from './pages/admin/AdminConfig';
import AdminProfile from './pages/admin/AdminProfile';

function App() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      verifyToken(token);
    } else {
      setLoading(false);
    }
  }, []);

  const verifyToken = async (token) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/verify`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.ok) {
        setIsAdmin(true);
      } else {
        localStorage.removeItem('adminToken');
        setIsAdmin(false);
      }
    } catch (error) {
      localStorage.removeItem('adminToken');
      setIsAdmin(false);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = (token) => {
    localStorage.setItem('adminToken', token);
    setIsAdmin(true);
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    setIsAdmin(false);
  };

  if (loading) {
    return (
      <div className="loading-screen" data-testid="loading-screen">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <Router>
      <div className="App" data-testid="app-root">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={
            <>
              <Navbar />
              <Home />
              <Footer />
            </>
          } />
          <Route path="/blog" element={
            <>
              <Navbar />
              <Blog />
              <Footer />
            </>
          } />
          <Route path="/blog/:slug" element={
            <>
              <Navbar />
              <SinglePost />
              <Footer />
            </>
          } />
          <Route path="/about" element={
            <>
              <Navbar />
              <About />
              <Footer />
            </>
          } />
          <Route path="/videos" element={
            <>
              <Navbar />
              <VideoHub />
              <Footer />
            </>
          } />
          <Route path="/contact" element={
            <>
              <Navbar />
              <Contact />
              <Footer />
            </>
          } />

          {/* Admin Routes */}
          <Route path="/admin/login" element={
            isAdmin ? <Navigate to="/admin/dashboard" /> : <AdminLogin onLogin={handleLogin} />
          } />
          <Route path="/admin/dashboard" element={
            isAdmin ? <AdminDashboard onLogout={handleLogout} /> : <Navigate to="/admin/login" />
          } />
          <Route path="/admin/posts" element={
            isAdmin ? <AdminPosts onLogout={handleLogout} /> : <Navigate to="/admin/login" />
          } />
          <Route path="/admin/posts/new" element={
            isAdmin ? <AdminPostForm onLogout={handleLogout} /> : <Navigate to="/admin/login" />
          } />
          <Route path="/admin/posts/edit/:slug" element={
            isAdmin ? <AdminPostForm onLogout={handleLogout} /> : <Navigate to="/admin/login" />
          } />
          <Route path="/admin/videos" element={
            isAdmin ? <AdminVideos onLogout={handleLogout} /> : <Navigate to="/admin/login" />
          } />
          <Route path="/admin/subscribers" element={
            isAdmin ? <AdminSubscribers onLogout={handleLogout} /> : <Navigate to="/admin/login" />
          } />
          <Route path="/admin/contacts" element={
            isAdmin ? <AdminContacts onLogout={handleLogout} /> : <Navigate to="/admin/login" />
          } />
          <Route path="/admin/config" element={
            isAdmin ? <AdminConfig onLogout={handleLogout} /> : <Navigate to="/admin/login" />
          } />
          <Route path="/admin/profile" element={
            isAdmin ? <AdminProfile onLogout={handleLogout} /> : <Navigate to="/admin/login" />
          } />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
